import {IFormContact} from "../components/FormContact/FormContact";

const apiURL = process.env.REACT_APP_API_URL;
const fetch_param = `?token=${process.env.REACT_APP_API_TOKEN}`;

export function getAddressByText(text) {
    return fetch(`${apiURL}/adresses/par-texte/${text}${fetch_param}`)
        .then(response => response.json())
        .catch(error => false);
}

export function getAddressByTel(numero) {
    return fetch(`${apiURL}/adresses/par-telephone/${numero}${fetch_param}`)
        .then(response => response.json())
        .catch(error => false);
}

export function getAddressByPosition(position) {
    return fetch(
        `${apiURL}/adresses/par-position/${position.lat}/${
            position.lon
            }${fetch_param}`
    )
        .then(response => response.json())
        .catch(error => false);
}

export function getOffreCuivreByAddress(rue, insee) {
    return fetch(
        `${apiURL}/cuivre/par-adresse/${rue}/${insee}${fetch_param}`
    )
        .then(response => response.json())
        .catch(error => false);
}

export function getEligibilityForCuivreByTel(numero) {
    if (numero) {
        return fetch(`${apiURL}/eligibilites/cuivre/${numero}${fetch_param}`)
            .then(response => response.json())
            .catch(error => false);
    } else {
        return Promise.resolve().then(() => ({data: []}));
    }
}

export function memoriserOrigineDeLInternaute()
{
    return fetch(`${apiURL}/comefrom/sauvegarder${fetch_param}`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({'query_string': window.location.href, 'referer': document.referrer})
        }
    )
        .then(response => response.json())
        .catch(error => false);
}

export function ajouterUnWebsite(formData : IFormContact) {
    if (formData) {
        return fetch(`${apiURL}/website/ajouter${fetch_param}`,
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(formData)
            }
        )
            .then(response => response.json())
            .catch(error => false);
    } else {
        return Promise.resolve().then(() => ({data: []}));
    }
}

export function getEligibilityForMobileByPosition(position) {
    return fetch(
        `${apiURL}/eligibilites/mobile-fibre/${position.lat}/${
            position.lon
            }${fetch_param}`
    )
        .then(response => response.json())
        .catch(error => false);
}

export function logEvent(event) {
    return fetch(`${apiURL}/journal${fetch_param}`, {
        method: "POST",
        body: JSON.stringify(event)
    })
        .then(response => true)
        .catch(error => false);
}